import { useContext, useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import config from '@app/config'
import { ChatContext } from '@app/context'
import { getSystemMessageTranslation } from '@app/helpers'
import { useUser, useIsStaff } from '@app/hooks'
import { ConversationItem, MessageItem } from '@app/models'
import { isB2BView } from '@app/utils'

export const useTranslatedSystemMessage = (
  message: MessageItem,
  conversation?: ConversationItem
): string | null => {
  const { t } = useTranslation()
  const { state } = useContext(ChatContext)
  const { currentUser } = useUser()
  const isStaff = useIsStaff()
  const isB2B = isB2BView()
  const regionalLanguage = config.regionalSettings?.language

  return useMemo(
    () =>
      getSystemMessageTranslation(
        message,
        conversation,
        t,
        state,
        currentUser?.id,
        isB2B,
        regionalLanguage,
        isStaff
      ),
    [
      conversation,
      currentUser?.id,
      isB2B,
      isStaff,
      message,
      regionalLanguage,
      state,
      t,
    ]
  )
}
